import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import Image from 'next/image'

import { Column, Section, Rows, Row } from '@/components/layout'
import { Text } from '@/components/common'

import styles from './TextImageRow.module.scss'

export default function TextImageRow({
  image,
  listItems,
  reverse = false,
  smallPrint,
  text,
  title,
}) {
  const renderText = () => {
    // Replace [br] with <br />
    const lines = text.split('[br]')
    return (
      lines.map((line, index) => (
        <React.Fragment key={line}>
          {line}
          {index < lines.length - 1 && <br />}
        </React.Fragment>
      ))
    )
  }

  const renderList = () => {
    if (listItems) {
      return (
        <ul>
          {Object.values(listItems).map((item) => (
            <li key={item}>{item}</li>
          ))}
        </ul>
      )
    }
    return null
  }

  return (
    <Section className={cx(styles.textImageRow, reverse ? styles.reverse : '')} paddingTop={0}>
      <Row>
        <Column center className={styles.imgSection} size={50}>
          <Image alt={title} className={styles.dataExtractImg} src={image} style={{ height: 'auto' }} />
        </Column>
        <Column center className={styles.textSection} size={50}>
          <Rows className="w-full">
            <Text.H2>{ title }</Text.H2>
            <Text.P>{renderText()}</Text.P>
            {renderList()}
            {smallPrint && <Text size="xsmall"><i>{smallPrint}</i></Text>}
          </Rows>
        </Column>
      </Row>
    </Section>
  )
}

TextImageRow.propTypes = {
  image: PropTypes.string,
  listItems: PropTypes.objectOf(PropTypes.string),
  reverse: PropTypes.bool,
  smallPrint: PropTypes.string,
  text: PropTypes.string,
  title: PropTypes.string,
}
